
export enum Format {
    Html = 1,
    Markdown = 2
}